export default __webpack_public_path__ + "static/media/email_icon.e44bd9c2.svg";